import { auditActionTypes as actionType } from 'src/constants/actionTypes';

const initialState = {
  fields: [],
  list: null,
  savedAuditSearchList: [],
  status: '',
  message: ''
};

const auditReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_FIELDS_SUCCESS: {
      const { fields } = action.payload;
      return {
        ...state,
        fields,
        status: 'success',
        message: ''
      };
    }

    case actionType.SEARCH_SUCCESS: {
      const { list } = action.payload;
      return {
        ...state,
        list,
        status: 'success',
        message: ''
      };
    }

    case actionType.SEARCH_CLEAR: {
      return {
        ...state,
        list: null,
        status: '',
        message: ''
      };
    }

    case actionType.EXPORT_SUCCESS: {
      return {
        ...state,
        status: 'success'
      };
    }
    case actionType.SAVE_SUCCESS: {
      const { savedAuditSearch, successMsg } = action.payload;
      return {
        ...state,
        savedAuditSearchList: [...state.savedAuditSearchList, savedAuditSearch],
        success: successMsg,
      };
    }

    case actionType.GET_ALL_SUCCESS: {
      const { savedAuditSearchList } = action.payload;
      return {
        ...state,
        savedAuditSearchList
      };
    }

    case actionType.DELETE_SUCCESS: {
      const { id } = action.payload;
      return {
        ...state,
        savedAuditSearchList: state.savedAuditSearchList.filter((search) => search.id !== id)
      };
    }
    case actionType.FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        message: error,
        status: 'error'
      };
    }
    case actionType.CLEAR_MESSAGES: {
      return {
        ...state,
        message: ''
      };
    }
    case actionType.SET_STATUS: {
      const { status } = action.payload;
      return {
        ...state,
        status
      };
    }

    default: {
      return state;
    }
  }
};

export default auditReducer;
